module.exports = __webpack_public_path__ + "static/gray_car-0da731b7028600035d89bf70a20388fe.jpg";